import { createQueryKeys } from '@lukemorales/query-key-factory';

export const credentialsQueries = createQueryKeys('credentials', {
  list: (candidateId: number) => ({
    queryKey: [candidateId],
  }),
});
